var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97909 3.5C2.7636 3.5 2.55693 3.42098 2.40456 3.28033C2.25219 3.13968 2.16659 2.94891 2.16659 2.75C2.16659 2.55109 2.25219 2.36032 2.40456 2.21967C2.55693 2.07902 2.7636 2 2.97909 2C3.19457 2 3.40124 2.07902 3.55361 2.21967C3.70598 2.36032 3.79158 2.55109 3.79158 2.75C3.79158 2.94891 3.70598 3.13968 3.55361 3.28033C3.40124 3.42098 3.19457 3.5 2.97909 3.5ZM11.597 5.79L6.722 1.29C6.527 1.11 6.25617 1 5.95825 1H2.16659C1.56534 1 1.08325 1.445 1.08325 2V5.5C1.08325 5.775 1.20242 6.025 1.40284 6.205L6.27242 10.705C6.47284 10.885 6.74367 11 7.04158 11C7.3395 11 7.61033 10.885 7.80533 10.705L11.597 7.205C11.7974 7.025 11.9166 6.775 11.9166 6.5C11.9166 6.22 11.792 5.97 11.597 5.79Z",
    fill: "#010048",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.2c7b2ed2970ae93716fa44f65e016bec.svg";
export { ForwardRef as ReactComponent };